import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { Button, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { customerJourneyMailUnsubscribe } from './../../actions';

import './mailunsubscribe.scss';

class MailUnsubscribe extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showConfirmationModal: false,
      showCancelModal: false
    };

    this.handleToggleMailSubscription = this.handleToggleMailSubscription.bind(this);
    this.handleCloseConfirmationModal = this.handleCloseConfirmationModal.bind(this);
    this.successMailUnsubscription = this.successMailUnsubscription.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleCloseCancelModal = this.handleCloseCancelModal.bind(this);
  }

  /* Methods */

  successMailUnsubscription() {
    this.setState({ showConfirmationModal: true });
  }

  /* Handlers */

  handleToggleMailSubscription(value) {
    this.props.actions.customerJourneyMailUnsubscribe(this.props.token, this.props.currentLanguage, this.successMailUnsubscription);
  }

  handleCloseConfirmationModal() {
    this.setState({ showConfirmationModal: false });
  }

  handleCancel(value) {
    this.setState({ showCancelModal: true });
  }

  handleCloseCancelModal() {
    this.setState({ showCancelModal: false });
  }

  /* Lifecycle */

  render() {
    const loading = this.props.reservation.loading;
    const subscriptionActive = this.props.reservation.apiData.mail_subscription_active;

    return (
      <Grid className="mailunsubscribe-component">
          <Row>
            <br/>
            <br/>
            <br/>
            <Col xs={12}>
              <h4 className="text-center">{subscriptionActive ? this.props.translate('mail_unsubscribe.subscribed_title') : this.props.translate('mail_unsubscribe.unsubscribed_title')}</h4>
              <h4 className="text-center mailunsubscribe-component__subtitle">{subscriptionActive ? this.props.translate('mail_unsubscribe.subscribed_subtitle') : this.props.translate('mail_unsubscribe.unsubscribed_subtitle')}</h4>
            </Col>
            <Col xs={12}>
              <br/>
              <div className="mailunsubscribe-component__mail-subscription-toggler text-center">
                <Button bsStyle="primary" disabled={loading} onClick={this.handleToggleMailSubscription}>{subscriptionActive ? this.props.translate('mail_unsubscribe.subscribed_confirm') : this.props.translate('mail_unsubscribe.unsubscribed_confirm')}</Button>
                <Button disabled={loading} onClick={this.handleCancel}>{subscriptionActive ? this.props.translate('mail_unsubscribe.subscribed_cancel') : this.props.translate('mail_unsubscribe.unsubscribed_cancel')}</Button>
              </div>
            </Col>
          </Row>

          {/* Confirmation Modal */}
          <Modal bsSize="sm" show={this.state.showConfirmationModal} onHide={this.handleCloseConfirmationModal}>
            <Modal.Body>
              <p>{subscriptionActive ? this.props.translate('mail_unsubscribe.confirmation.activate.confirm') : this.props.translate('mail_unsubscribe.confirmation.deactivate.confirm')}</p>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleCloseConfirmationModal}>Ok</Button>
            </Modal.Footer>
          </Modal>

        {/* Cancel Modal */}
        <Modal bsSize="sm" show={this.state.showCancelModal} onHide={this.handleCloseCancelModal}>
          <Modal.Body>
            <p>{!subscriptionActive ? this.props.translate('mail_unsubscribe.confirmation.activate.cancel') : this.props.translate('mail_unsubscribe.confirmation.deactivate.cancel')}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleCloseCancelModal}>Ok</Button>
          </Modal.Footer>
        </Modal>

      </Grid>
    );
  }
}

MailUnsubscribe.displayName = 'PagesMailUnsubscribe';
MailUnsubscribe.propTypes = {};
MailUnsubscribe.defaultProps = {};

const mapStateToProps = (state) => {
  return {
      translate: getTranslate(state.locale),
      currentLanguage: getActiveLanguage(state.locale).code,
      token: state.commons.token,
      context: state.commons.context,
      reservation: state.reservation
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      customerJourneyMailUnsubscribe: bindActionCreators(customerJourneyMailUnsubscribe, dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MailUnsubscribe);



// WEBPACK FOOTER //
// ./components/pages/MailUnsubscribe.js